import capitalize from 'underscore.string/capitalize';

angular
  .module 'filters'
  .filter 'capitalize', ->
    (data) ->
      capitalize(data)
